import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolders2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folders-2, collection, stuff"><path d="M5.75 16.25V3.75H10.25L12.25 5.75H21.25V16.25H5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 6.75V19.25H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolders2;
